import Map from './map';
import fileDownload from 'js-file-download';
import { b64toBlob } from 'scripts/Utilities/core';
import { displayMessage, messageType } from 'scripts/Utilities/notification';
import { getResource } from 'scripts/Utilities/resources';

declare let globalVariables: any;

const map = new Map({
    mapMode: globalVariables.mapMode
});

export function beforeSendSearch(jqXHR, settings) {
    if ($(this).find("[name='LimitSearchExtent']:checked").length < 1) {
        return;
    }

    const data = map.getExtent();
    if (settings.type == "GET") {
        settings.url = `${settings.url}&${$.param(data, true)}`;
    }
    else {
        settings.data = $.extend(settings.data, data);
    }
}

export function successSearch(data) {
    map.successSearch(data);
}

export function successSearchOrExportTriangulation(data) {
    if (data.indexOf('fileName') != -1 && data.indexOf('fileData') != -1) {
        let res = JSON.parse(data);
        let fileName = res.fileName;
        fileDownload(b64toBlob(res.fileData), `${fileName}.zip`);
    } else {
        let targetId = "IsToBeExportedTriangulation";
        successSearchOrExport(data, targetId);
    }
}

export function successSearchOrExportGnlpGnss(data) {
    if (data.indexOf('fileName') != -1 && data.indexOf('fileData') != -1) {
        let res = JSON.parse(data);
        let fileName = res.fileName;
        fileDownload(b64toBlob(res.fileData), `${fileName}.zip`);
    } else {
        let targetId = "IsToBeExportedGnlpGnss";
        successSearchOrExport(data, targetId);
    }
}

export function successSearchOrExportGnlpObjects(data) {
    let targetId = "IsToBeExportedGnlpObjects";
    successSearchOrExport(data, targetId);
}

export function successSearchOrExportPhotogrammetry(data) {
    let targetId = "IsToBeExportedPhotogrammetry";
    successSearchOrExport(data, targetId);
}

export function successSearchOrExportLandBalance(data) {
    let targetId = "IsToBeExportedLandBalance";
    successSearchOrExport(data, targetId);
}

export function successSearchOrExportOtherTopoMaps(data) {
    let targetId = "IsToBeExportedOtherTopoMaps";
    successSearchOrExport(data, targetId);
}

export function successSearchOrExportLevelCycleIII(data) {
    let targetId = "IsToBeExportedLevelCycleIII";
    successSearchOrExport(data, targetId);
}

export function successSearchOrExportLevelCycleIV(data) {
    let targetId = "IsToBeExportedLevelCycleIV";
    successSearchOrExport(data, targetId);
}

export function successSearchOrExportLevelCycleV(data) {
    let targetId = "IsToBeExportedLevelCycleV";
    successSearchOrExport(data, targetId);
}

export function successSearchOrExportLevelBoundary(data) {
    let targetId = "IsToBeExportedLevelBoundary";
    successSearchOrExport(data, targetId);
}

export function successSearchOrExportLevelMareographic(data) {
    let targetId = "IsToBeExportedLevelMareographic";
    successSearchOrExport(data, targetId);
}

export function successSearchOrExportGravimetricPoints(data) {
    let targetId = "IsToBeExportedGravimetricPoints";
    successSearchOrExport(data, targetId);
}

export function successSearchOrExportTideStations(data) {
    let targetId = "IsToBeExportedTideStations";
    successSearchOrExport(data, targetId);
}

export function successSearchOrExportArchivePlans(data) {
    let targetId = "IsToBeExportedArchivePlan";
    successSearchOrExport(data, targetId);
}

export function successSearchOrExportLargeScaleTopoMaps70(data) {
    let targetId = "IsToBeExportedLargeScaleTopoMaps70";
    successSearchOrExport(data, targetId, "ЕТК в КС 1970");
}

export function successSearchOrExportLargeScaleTopoMaps50(data) {
    let targetId = "IsToBeExportedLargeScaleTopoMaps50";
    successSearchOrExport(data, targetId, "ЕТК в КС 1950");
}

export function successSearchOrExportLargeScaleTopoMaps2005(data) {
    let targetId = "IsToBeExportedLargeScaleTopoMaps2005";
    successSearchOrExport(data, targetId, "ЕТК в БГС 2005");
}

export function successSearchOrExportSpecializedMap(data) {
    let targetId = "IsToBeExportedCoastCadSpecialized";
    successSearchOrExport(data, targetId);
}

export function successSearchOrExportSpecializedToDateMap(data) {
    let targetId = "IsToBeExportedCoastCadSpecializedToDate";
    successSearchOrExport(data, targetId);
}

export function successSearchOrExportCoastCadRegister(data) {
    let targetId = "IsToBeExportedCoastCadRegister";
    successSearchOrExport(data, targetId);
}

function handleLoadingExportIndicator(show: boolean) {
    let loadingIndicator = $('#export-loading-indicator')[0];

    if (!loadingIndicator) {
        loadingIndicator = document.createElement('div');
        loadingIndicator.setAttribute('id', 'export-loading-indicator');
        loadingIndicator.setAttribute('class', 'gkf-export-indicator');
    }

    if (show) {
        $('#map-search').append(loadingIndicator);
        $('#export-loading-indicator').kendoLoader({
            size: 'large'
        }).data("kendoLoader");
    } else {
        loadingIndicator.remove();
    }
}

export function successSearchOrExport(data, targetId, fileName?: string) {
    if (data) {
        let tempEl = document.createElement('html');
        tempEl.innerHTML = data;
        if (tempEl.getElementsByClassName('object-control').length) {
            if (tempEl.getElementsByClassName('k-tooltip-bottom').length) {
                $(`#exportBtn-${targetId}`).show();
            } else {
                $(`#exportBtn-${targetId}`).hide();
            }
        }
        else if (tempEl.getElementsByClassName('register').length) {
            $(`#exportBtn-${targetId}`).show();
        }
        //else {
        //    $(`#exportBtn-${targetId}`).hide();
        //}
    }
    let targetCheckBox = $(`#${targetId}`).data("kendoCheckBox") as kendo.ui.CheckBox;
    if (!targetCheckBox) {
        successSearch(data);
        return;
    }
    if (!targetCheckBox.check()) {
        successSearch(data);
    } else {
        try {
            if (fileName) {
                if (data) {
                    fileDownload(b64toBlob(data), `${fileName}.xlsx`);
                }
                return;
            }
            let exportData = JSON.parse(data);
            if (exportData.dataId) {
                exportDataById(exportData.dataId, exportData.fileName);
            } else if (exportData.length) {
                exportMultipleData(exportData);
            }
        } catch (e) {
            console.error(e);
        }
    }
}

function fetchJobIdStatus(url, id) {
    return new Promise((resolve, reject) => {
        $.ajax({
            url,
            type: "GET",
            success: function (data) {
                resolve(data)
            },
            error: function (error) {
                reject(error)
            }
        })
    });
}

function fetchExportExcelFile(url: string, fileName: string) {
    return new Promise((resolve, reject) => {
        $.ajax({
            url,
            type: "GET",
            xhr: function () {
                let xhr = new XMLHttpRequest();
                xhr.responseType = 'blob'
                return xhr;
            },
            success: function (data) {
                fileDownload(data, `${fileName}.xlsx`);
                handleLoadingExportIndicator(false);
            },
            error: function (error) {
                console.error(error);
                handleLoadingExportIndicator(false);
            }
        })
    })
}

function exportMultipleData(multipleDataExport: Array<{ layerTitle: string; jobId: string }>) {
    const allQueryData = multipleDataExport.map(d => ({ ...d, status: "pending" }));

    allQueryData.forEach(exp => {
        exportMultipleDataById(exp, allQueryData)
    });
}

function exportMultipleDataById(data, allQueries) {
    handleLoadingExportIndicator(true);
    setTimeout(() => {
        let getJobStatusUrl = `${globalVariables.exportCheckUrl}/${data.jobId}`;
        fetchJobIdStatus(getJobStatusUrl, data.jobId)
            .then((exportStatus) => {
                if (exportStatus === 5) {
                    exportMultipleFileStatus(data.layerTitle, 'completed', allQueries);
                } else if (exportStatus === 7) {
                    console.error('failure');
                    handleLoadingExportIndicator(false);
                } else {
                    const intervalId = setInterval(() => {
                        fetchJobIdStatus(getJobStatusUrl, data.jobId)
                            .then((exportStatus) => {
                                if (exportStatus === 5) {
                                    clearInterval(intervalId);
                                    exportMultipleFileStatus(data.layerTitle, 'completed', allQueries);
                                } else if (exportStatus === 7) {
                                    clearInterval(intervalId);
                                    console.error('failure');
                                    handleLoadingExportIndicator(false);
                                }
                            })
                            .catch((err) => {
                                clearInterval(intervalId);
                                exportMultipleFileStatus(data.layerTitle, 'rejected', allQueries);
                            });
                    }, 10000);
                }
            })
            .catch(err => {
                console.error(err);
                handleLoadingExportIndicator(false);
            })
    }, 2000);
}

function exportMultipleFileStatus(layerTitle: string, requestSatus: 'rejected' | 'completed', allQueriess: Array<{ layerTitle: string; jobId: string; status: 'rejected' | 'completed' | 'pending' }>) {
    for (let i = 0; i < allQueriess.length; i++) {
        if (allQueriess[i].layerTitle === layerTitle) {
            allQueriess[i].status = requestSatus;
            break;
        }
    }

    const isFinished = allQueriess.some(s => s.status === 'pending');
    if (!isFinished) {
        const shapeFilesData = allQueriess.map(shpReqInfo => ({
            fileName: shpReqInfo.layerTitle,
            id: shpReqInfo.jobId
        }));

        fetchMultipleExportExcelFile(
            `${globalVariables.exportGetUrl}/multiple`,
            shapeFilesData,
            `${new Date().getTime().toString().substring(8)}`
        );
    }
}

function fetchMultipleExportExcelFile(url: string, exportData, fileName: string) {
    $.ajax({
        url,
        data: JSON.stringify(exportData),
        contentType: "application/json; charset=utf-8",
        type: "POST",
        xhr: function () {
            let xhr = new XMLHttpRequest();
            xhr.responseType = 'blob'
            return xhr;
        },
        success: function (data) {
            handleLoadingExportIndicator(false);
            fileDownload(data, `${fileName}.zip`);
        },
        error: function (error) {
            console.error(error);
            handleLoadingExportIndicator(false);
        }
    })
}

function exportDataById(exportId: string, fileName: string) {
    handleLoadingExportIndicator(true);
    setTimeout(() => {
        let getJobStatusUrl = `${globalVariables.exportCheckUrl}/${exportId}`;
        let getJobResultUrl = `${globalVariables.exportGetUrl}/${exportId}`;
        let _fileName = fileName ? fileName : `Export_${(new Date().getTime() + '').substr(5)}`;

        fetchJobIdStatus(getJobStatusUrl, exportId)
            .then((exportStatus) => {
                if (exportStatus === 5) {
                    fetchExportExcelFile(getJobResultUrl, _fileName);
                } else if (exportStatus === 7) {
                    console.error('failure');
                    handleLoadingExportIndicator(false);
                } else {
                    const intervalId = setInterval(() => {
                        fetchJobIdStatus(getJobStatusUrl, exportId)
                            .then((exportStatus) => {
                                if (exportStatus === 5) {
                                    clearInterval(intervalId);
                                    fetchExportExcelFile(getJobResultUrl, _fileName);
                                } else if (exportStatus === 7) {
                                    clearInterval(intervalId);
                                    console.error('failure');
                                    handleLoadingExportIndicator(false);
                                }
                            })
                            .catch((err) => {
                                clearInterval(intervalId);
                                handleLoadingExportIndicator(false);
                            });
                    }, 10000);
                }
            })
            .catch((err) => {
                handleLoadingExportIndicator(false);
            });
    }, 2000);
}

export const onObjectResultDataBound = (e: kendo.ui.ListViewEvent) => {
    let total = e.sender.dataSource.total();
    switch (total) {
        case 0: {
            e.sender.wrapper.parent().replaceWith(`<label>${getResource("NoDataFound")}</label>`);
            break;
        }

        case 1: {
            e.sender.element.find(".object-option.zoom-js:first").trigger("click");
            break;
        }
    }
}

export function esriBeforeSearch(jqXHR, settings) {
    if ($(this).find("[name='LimitSearchExtent']:checked").length < 1) {
        return;
    }

    const data = map.getExtent();
    if (settings.type == "GET") {
        settings.url = `${settings.url}&${$.param(data, true)}`;
    }
    else {
        settings.data = settings.data + `&EsriExtent=${JSON.stringify(data.Extent)}&Projection=${data.Projection}`;
    }
}

function handleLoadingMapExportIndicator(show: boolean) {
    let loadingIndicator = $('#export-map-loading-indicator')[0];
    if (!loadingIndicator) {
        loadingIndicator = document.createElement('div');
        loadingIndicator.setAttribute('id', 'export-map-loading-indicator');
        loadingIndicator.setAttribute('class', 'map-print-loading-indicator');
    }

    if (show) {
        $('.map-print-container').append(loadingIndicator);
        $('#export-map-loading-indicator').kendoLoader({
            size: 'large'
        }).data("kendoLoader");
    } else {
        loadingIndicator.remove();
    }
}

export function handleMapExport(payload: string) {
    handleLoadingMapExportIndicator(true);
    getMapExportExecute(globalVariables.mapExportExecuteUrl);
    getMapExportJobId(globalVariables.mapExportSubmitJobUrl, payload)
        .then((res: string) => {
            const jobId = res;
            refetchMapExportJobStatus(globalVariables.mapExportCheckJobUrl, jobId);
        })
        .catch((error) => {
            console.error(error);
            displayMessage(getResource('Failure'), messageType.error);
            handleLoadingMapExportIndicator(false);
        });
}

function getMapExportExecute(url: string) {
    const _url = `${url}?f=json`;
    return new Promise((resolve, reject) => {
        $.ajax({
            url: _url,
            type: "GET",
            success: function (data) {
                resolve(data);
            },
            error: function (error) {
                console.error(error);
                displayMessage(getResource('Failure'), messageType.error);
                handleLoadingMapExportIndicator(false);
            }
        });
    });
};

function getMapExportJobId(url: string, payload: string) {
    return new Promise((resolve, reject) => {
        $.ajax({
            url,
            type: "POST",
            xhr: function () {
                let xhr = new XMLHttpRequest();
                let setRequestHeader = xhr.setRequestHeader;
                xhr.setRequestHeader = function (name, value) {
                    if (name == 'X-CSRF-TOKEN') return;
                    setRequestHeader.call(this, name, value);
                };
                return xhr;
            },
            data: JSON.parse(payload),
            success: function (data) {
                resolve(data.jobId);
            },
            error: function (error) {
                reject(error);
            }
        });
    });
};

function fetchMapExportJobStatus(url: string, jobId: string) {
    const _url = `${url}/${jobId}?f=json`;
    return new Promise((resolve, reject) => {
        $.ajax({
            url: _url,
            type: "GET",
            success: function (data) {
                resolve(data.jobStatus);
            },
            error: function (error) {
                reject(error);
            }
        });
    });
};

function refetchMapExportJobStatus(url: string, jobId: string) {
    setTimeout(() => {
        fetchMapExportJobStatus(url, jobId)
            .then((exportStatus) => {
                if (exportStatus === "esriJobSucceeded") {
                    fetchExportMap(url, jobId);
                } else if (exportStatus === "esriJobFailed") {
                    console.error('Failure');
                    displayMessage(getResource('Failure'), messageType.error);
                    handleLoadingMapExportIndicator(false);
                } else {
                    const startTime = new Date().getTime();
                    const intervalId = setInterval(() => {
                        const mapExportTimeout = globalVariables.mapExportTimeout || 120000;
                        if (new Date().getTime() - startTime > mapExportTimeout) {
                            clearInterval(intervalId);
                            console.error('Failure');
                            displayMessage(getResource('Failure'), messageType.error);
                            handleLoadingMapExportIndicator(false);
                            return;
                        }
                        fetchMapExportJobStatus(url, jobId)
                            .then((exportStatus) => {
                                if (exportStatus === "esriJobSucceeded") {
                                    clearInterval(intervalId);
                                    fetchExportMap(url, jobId);
                                } else if (exportStatus === "esriJobFailed") {
                                    clearInterval(intervalId);
                                    console.error('Failure');
                                    displayMessage(getResource('Failure'), messageType.error);
                                    handleLoadingMapExportIndicator(false);
                                }
                            })
                            .catch((error) => {
                                clearInterval(intervalId);
                                console.error(error);
                                displayMessage(getResource('Failure'), messageType.error);
                                handleLoadingMapExportIndicator(false);
                            });
                    }, 10000);
                }
            })
            .catch((error) => {
                console.error(error);
                displayMessage(getResource('Failure'), messageType.error);
                handleLoadingMapExportIndicator(false);
            });
    }, 2000);
}

function fetchExportMap(url: string, jobId: string) {
    const _url = `${url}/${jobId}/results/Output_File?returnType=data&f=json`
    return new Promise((resolve, reject) => {
        $.ajax({
            url: _url,
            type: "GET",
            success: function (data) {
                const url = data.value.url;
                fetchMapExportPdfFile(url);
            },
            error: function (error) {
                console.error(error);
                displayMessage(getResource('Failure'), messageType.error);
                handleLoadingMapExportIndicator(false);
            }
        });
    });
};

function fetchMapExportPdfFile(url: string) {
    return new Promise((resolve, reject) => {
        $.ajax({
            url,
            type: "GET",
            xhr: function () {
                let xhr = new XMLHttpRequest();
                xhr.responseType = 'blob'
                return xhr;
            },
            success: function (data) {
                fileDownload(data, "Map.pdf");
                handleLoadingMapExportIndicator(false);
            },
            error: function (error) {
                console.error(error);
                displayMessage(getResource('Failure'), messageType.error);
                handleLoadingMapExportIndicator(false);
            }
        })
    })
}

export const onSelectGkfAdminAutoComplete = (e: kendo.ui.AutoCompleteSelectEvent) => {
    e.preventDefault();
    let dataItem = e.dataItem;
    e.sender.value(dataItem["Title"]);
    let form = e.sender.element.closest("form");
    let idInputEl = form.find("input[name='GeoAdminObject']");
    idInputEl!.val(dataItem!["Id"]);
}

export const gkfAdminAutoCompleteFilter = (e) => {
    return {
        filterText: e.filter.filters[0]?.value,
    }
}

function handleLoadingFileUploadIndicator(show: boolean) {
    var loadingIndicator = $('#upload-file-loading-indicator')[0];
    if (!loadingIndicator) {
        loadingIndicator = document.createElement('div');
        loadingIndicator.setAttribute('id', 'upload-file-loading-indicator');
        loadingIndicator.setAttribute('class', 'map-print-loading-indicator');
    }

    if (show) {
        $('#upload-extent').append(loadingIndicator);
        $('#upload-file-loading-indicator').kendoLoader({
            size: 'large'
        }).data("kendoLoader");
    } else {
        loadingIndicator.remove();
    }
}

export function handleCustomFileUpload(file: File, type: string, wkid?: string) {
    const apiUrl = globalVariables.uploadCustomFileApiUrl;
    handleLoadingFileUploadIndicator(true);
    getFileUploadJobId(apiUrl, file, type, wkid)
        .then((res: string) => {
            const jobId = res;
            refetchFileUploadJobStatus(apiUrl, jobId, type, file.name);
        })
        .catch((error) => {
            console.error(error);
            displayMessage(getResource('Failure'), messageType.error);
            handleLoadingFileUploadIndicator(false);
        });
}

function getFileUploadJobId(url: string, file: File, type: string, wkid?: string) {
    let _url = "";
    let formData = new FormData();
    if (type === "dwg" && wkid) {
        _url = `${url}/dwg/selected`;
        formData.append('File', file);
        formData.append('WKID', wkid);
    } else {
        _url = `${url}/shape/selected`;
        formData.append('File', file);
    }

    return new Promise((resolve, reject) => {
        $.ajax({
            url: _url,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            enctype: 'multipart/form-data',
            success: (data) => {
                resolve(data);
            },
            error: (error) => {
                reject(error);
            }
        });
    })
}

function fetchFileUploadJobStatus(url: string, jobId: string) {
    const _url = `${url}/check/${jobId}`;
    return new Promise((resolve, reject) => {
        $.ajax({
            url: _url,
            type: "GET",
            success: (data) => {
                resolve(data);
            },
            error: (error) => {
                reject(error);
            }
        })
    })
}

function getCustomConvertedToJson(url: string, jobId: string) {
    const _url = `${url}/get/${jobId}`;
    return new Promise((resolve, reject) => {
        $.ajax({
            url: _url,
            type: "GET",
            success: (data) => {
                resolve(data);
            },
            error: (error) => {
                reject(error);
            }
        })
    });
}

function refetchFileUploadJobStatus(url: string, jobId: string, type: string, fileName: string) {
    setTimeout(() => {
        fetchFileUploadJobStatus(url, jobId)
            .then((jobStatus) => {
                if (jobStatus === "Complete") {
                    getCustomConvertedToJson(url, jobId)
                        .then((res) => {
                            if (type === 'dwg') {
                                map.drawDwgResult(res, fileName);
                            } else {
                                map.drawShpResult(res, fileName);
                            }
                            handleLoadingFileUploadIndicator(false);
                        })
                        .catch((error) => {
                            displayMessage(getResource('Failure'), messageType.error);
                            handleLoadingFileUploadIndicator(false);
                        });
                } else if (jobStatus === "Faulted") {
                    console.error('Failure');
                    displayMessage(getResource('Failure'), messageType.error);
                    handleLoadingFileUploadIndicator(false);
                } else if (jobStatus === "InProgress") {
                    const startTime = new Date().getTime();
                    const endTime = startTime + (globalVariables.customFileUploadTimeout || 120000);
                    const intervalId = setInterval(() => {
                        if (new Date().getTime() > endTime) {
                            clearInterval(intervalId);
                            console.error('Failure');
                            displayMessage(getResource('Failure'), messageType.error);
                            handleLoadingFileUploadIndicator(false);
                            return;
                        }
                        fetchFileUploadJobStatus(url, jobId)
                            .then((jobStatus) => {
                                if (jobStatus === "Complete") {
                                    clearInterval(intervalId);
                                    getCustomConvertedToJson(url, jobId)
                                        .then((res) => {
                                            if (type === 'dwg') {
                                                map.drawDwgResult(res, fileName);
                                            } else {
                                                map.drawShpResult(res, fileName);
                                            }
                                            handleLoadingFileUploadIndicator(false);
                                        })
                                        .catch((error) => {
                                            console.error(error);
                                            displayMessage(getResource('Failure'), messageType.error);
                                            handleLoadingFileUploadIndicator(false);
                                        });
                                } else if (jobStatus === "Faulted") {
                                    clearInterval(intervalId);
                                    console.error('Failure');
                                    displayMessage(getResource('Failure'), messageType.error);
                                    handleLoadingFileUploadIndicator(false);
                                }
                            })
                            .catch((error) => {
                                clearInterval(intervalId);
                                console.error(error);
                                displayMessage(getResource('Failure'), messageType.error);
                                handleLoadingFileUploadIndicator(false);
                            })
                    }, 10000)
                }
            })
            .catch((error) => {
                console.error(error);
                displayMessage(getResource('Failure'), messageType.error);
                handleLoadingFileUploadIndicator(false);
            })
    }, 10000);
}

export const renderObjectValueCustomTemplate = (data: any, name: string, value: string) => {
    switch (data[name]) {
        case "_floors":
            {
                return kendo.template($("#cadFileFloorTemplate").html())(data[value]);
            }

        default:
            return data[value];
    }
}